module.exports = __webpack_public_path__ + "static/img/5a.b19c5a8b.png";